
import React from 'react';
import 'antd/dist/antd.css';
import { Col, Layout, Menu, Row } from 'antd';
import { Link } from 'gatsby';
import cover3 from '../../images/cover.jpg'
import cover1 from '../../images/digital-transformation-cover.jpg';
import cover2 from '../../images/digital-marketing-cover.jpeg';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography } from 'antd';
import { Button } from 'antd';
import partner from '../../images/salesforce-partner.png';

const { Title } = Typography;

export const Section1 = (props: any) => (
  <Row className="row" style={{backgroundBlendMode: "overlay", background: `url(${cover1})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundColor: "#00000050"}}>
      <Col md={20} className="vh-100 order-2 order-md-1 d-flex flex-column justify-content-center">
          <div className="px-5" style={{textAlign: "left"}} >
            <Title className="text-light"> We Bring Digital Transformation to your Business</Title>
            <span className="text-light border-top" style={{paddingRight: "12em"}}> </span><br />
            <img width="200" src={partner} />
            {/* <Link to="/contact-us">
              <Button className="px-5 mt-2" type="primary" shape="round" size="large" style={{backgroundColor: "#dffcff", color: "#2c494c", borderColor: "#2c494c"}}>
                  Contact Us
              </Button>
            </Link> */}
          </div>
      </Col>
  </Row>
);

export const Section2 = (props: any) => (
  <Row className="row" style={{backgroundBlendMode: "overlay", background: `url(${cover2})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundColor: "#00000050"}}>
    <Col md={12} sm={0} xs={0} className="col-sm-6 col-xs-1"></Col>
    <Col md={12} sm={24} xs={24} className="vh-100 order-1 order-md-1 d-flex flex-column justify-content-center">
        <div className="px-5" style={{textAlign: "right"}} >
          <Title style={{fontSize: "3em"}} className="pt-1 text-light">Digital Marketing made easy </Title>
          <div className="text-light border-top" style={{paddingRight: "12em"}}> </div>
          <Title level={4} className="text-light mt-4">With the help of Salesforce Marketing Cloud Marketing process of businesses are made easy and efficient</Title>
        </div>
    </Col>
  </Row>
);
  
export const Section3 = (props: any) => (
  <div className="row" style={{backgroundBlendMode: "overlay", background: `url(${cover3})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundColor: "#00000050"}}>
    <div className="col-sm-6 col-xs-1"></div>
      <div className="vh-100 col-sm-6 col-xs-7 order-1 order-md-1 d-flex flex-column justify-content-center">
          <div className="px-5" style={{textAlign: "right"}} >
            <Title style={{fontSize: "3em"}} className="pt-1 text-light">Digital Marketing made easy </Title>
            <div className="text-light border-top" style={{paddingRight: "12em"}}> </div>
            <Title level={4} className="text-light mt-4">With the help of Salesforce Marketing Cloud Marketing process of businesses are made easy and efficient</Title>
          </div>
      </div>
  </div>
);
